export enum EncounterStatusEnum {
    ForReview = 1,
    ToSubmit = 2,
    Submitted = 4,
    Accepted = 5,
    Rejected = 6,
}
